import { Button } from 'primereact/button';
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Growl } from "primereact/growl";
import React from "react";
import servicioHttp from '../servicio/ServicioHttp';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import servicioObjetos from '../servicio/ServicioObjetos';


const MENSAJE_REQUERIDO = "Información requerida";
export class Isr extends React.Component {


    constructor() {
        super();
        this.state = {
            paginacion: { registrosPorPagina: 30 },
            paginacionS: { registrosPorPagina: 30 },
            mostrarDialog: false,
            mostrarDialogDos: false,
            mostrarModalEliminar: false,
            mostrarModalEliminarDos: false,
            isr: {},
            errores: {},
            desarrollador: false
        };
    }

    componentDidMount() {
        this.isrMensual();
        this.subsidioMensual();
        this.obtnerUsuarioDesarrollador();
    }

    obtnerUsuarioDesarrollador = () => {
        servicioHttp.consumirPostHttp('usuario/obtener_usuario_sesion_perfil.json').then(response => {
            if (response.data.mensaje === "existe") {
                this.setState({ desarrollador: true });
            }
        }).catch(error => {
        });
    }

    isrMensual = () => {
        servicioHttp.consumirPostHttp("isr/consulta_isr_mensual.json").then(response => {
            this.setState({ paginacion: response.data.objeto });
        }).catch(error => {
        });
    }

    subsidioMensual = () => {
        servicioHttp.consumirPostHttp("subsidio/consulta_subsidio_empleo_mensual.json").then(response => {
            this.setState({ paginacionS: response.data.objeto });
        }).catch(error => {
        });
    }

    columnaPorcentaje = (rowData, column) => {
        return <div>{rowData.porcentaje}%</div>;
    }

    plantillaOpciones = (rowData, column) => {
        return <div className="p-grid">
            <div className="p-col-12 p-md-12">
                <Button type="button" icon="pi-md-edit" onClick={(e) => this.actualizar(column.rowData)}
                    className="p-button-warning" name="editar" tooltip="Editar información">
                </Button>
            </div>
            <div className="p-col-12 p-md-6">
                <Button type="button" icon="pi-md-delete" onClick={(e) => this.mostrarModalEliminar(column.rowData)}
                    className="p-button-danger" name="eliminar" tooltip="Eliminar registro" >
                </Button>
            </div>
        </div>;
    }

    plantillaOpcionesDos = (rowData, column) => {
        return <div className="p-grid">
            <div className="p-col-12 p-md-12">
                <Button type="button" icon="pi-md-edit" onClick={(e) => this.actualizarDos(column.rowData)}
                    className="p-button-warning" name="editarDos" tooltip="Editar información">
                </Button>
            </div>
            <div className="p-col-12 p-md-6">
                <Button type="button" icon="pi-md-delete" onClick={(e) => this.mostrarModalEliminarDos(column.rowData)}
                    className="p-button-danger" name="eliminar" tooltip="Eliminar registro" >
                </Button>
            </div>
        </div>;
    }

    actualizar = (objeto) => {
        var isrEditar = JSON.parse(JSON.stringify(objeto));
        this.setState({ mostrarDialog: true, isr: isrEditar });
    }

    actualizarDos = (objeto) => {
        var isrEditar = JSON.parse(JSON.stringify(objeto));
        this.setState({ mostrarDialogDos: true, isr: isrEditar });
    }

    mostrarModal = () => {
        this.setState({ mostrarDialog: true });
    }

    mostrarModalEliminar = (objeto) => {
        this.setState({ mostrarModalEliminar: true, isr: objeto });
    }

    mostrarModalEliminarDos = (objeto) => {
        this.setState({ mostrarModalEliminarDos: true, isr: objeto });
    }

    mostrarModalDos = () => {
        this.setState({ mostrarDialogDos: true });
    }

    cerrarModal = () => {
        this.setState({ mostrarDialog: false });
        this.reset();
    }

    cerrarModalDos = () => {
        this.setState({ mostrarDialogDos: false });
        this.reset();
    }

    cerrarModalEliminar = () => {
        this.setState({ mostrarModalEliminar: false });
        this.reset();
    }

    cerrarModalEliminarDos = () => {
        this.setState({ mostrarModalEliminarDos: false });
        this.reset();
    }

    asignarValor = (event, mayusculas) => {
        servicioObjetos.asignarAtributosObjeto(event, this, mayusculas);
    };

    validarFormulario = (isr) => {
        let errores = {};

        if (servicioObjetos.esObjetoVacio(isr.limiteInferior)) {
            errores.limiteInferior = MENSAJE_REQUERIDO;
        }
        if (servicioObjetos.esObjetoVacio(isr.cuotaFija)) {
            errores.cuotaFija = MENSAJE_REQUERIDO;
        }
        if (servicioObjetos.esObjetoVacio(isr.porcentaje)) {
            errores.porcentaje = MENSAJE_REQUERIDO;
        }
        return errores;
    }

    validarFormularioS = (isr) => {
        let errores = {};

        if (servicioObjetos.esObjetoVacio(isr.limiteInferior)) {
            errores.limiteInferior = MENSAJE_REQUERIDO;
        }
        if (servicioObjetos.esObjetoVacio(isr.subsidio)) {
            errores.subsidio = MENSAJE_REQUERIDO;
        }
        return errores;
    }

    editarIsr = () => {
        let { isr } = this.state;
        let validForm = this.validarFormulario(isr);
        this.setState({ errores: validForm });
        if (!Object.keys(validForm).length) {
            let isrMensual = { ...isr };
            servicioHttp.consumirPostHttp("isr/actualizar_isr.json", isrMensual).then(response => {
                this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
                this.componentDidMount();
                this.cerrarModal();
            }).catch(error => {
                return this.growl.show({ severity: 'error', summary: '', detail: 'Se generó un error inesperado!!!, por favor inténtelo de nuevo' });
            })
        }
    }

    eliminarIsr = () => {
        let { isr } = this.state;
        servicioHttp.consumirPostHttp("isr/eliminar_isr.json", isr).then(response => {
            this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
            this.componentDidMount();
            this.cerrarModalEliminar();
        }).catch(error => {
            return this.growl.show({ severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
        })

    }

    editarSubsidio = () => {
        let { isr } = this.state;
        let validForm = this.validarFormularioS(isr);
        this.setState({ errores: validForm });
        if (!Object.keys(validForm).length) {
            let isrSubsidio = { ...isr };
            servicioHttp.consumirPostHttp("subsidio/actualizar_subsidio.json", isrSubsidio).then(response => {
                this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
                this.componentDidMount();
                this.cerrarModalDos();
            }).catch(error => {
                return this.growl.show({ severity: 'error', summary: '', detail: 'Se generó un error inesperado!!!, por favor inténtelo de nuevo' });
            })
        }
    }

    eliminarSubsidio = () => {
        let { isr } = this.state;
        servicioHttp.consumirPostHttp("subsidio/eliminar_subsidio.json", isr).then(response => {
            this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
            this.componentDidMount();
            this.cerrarModalEliminarDos();
        }).catch(error => {
            return this.growl.show({ severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
        })

    }

    reset = () => {
        this.setState({
            isr: {},
            errores: {}
        });
    }

    render() {
        let { paginacion, paginacionS, mostrarDialog, isr, errores, mostrarDialogDos, mostrarModalEliminar, mostrarModalEliminarDos, desarrollador } = this.state;

        const pieDialogEditar = (
            <div>
                <Button label="Aceptar" icon="pi-md-check" onClick={this.editarIsr} />
                <Button label="Cancelar" icon="pi-md-close" onClick={this.cerrarModal} className="p-button-danger" />
            </div>
        );

        const pieDialogEliminar = (
            <div>
                <Button icon="pi-md-check" onClick={this.eliminarIsr} label="Si estoy seguro" />
                <Button icon="pi-md-close" onClick={this.cerrarModalEliminar} label="No estoy seguro" className="p-button-danger flat-btn" />
            </div>
        );

        const pieDialogEditarDos = (
            <div>
                <Button label="Aceptar" icon="pi-md-check" onClick={this.editarSubsidio} />
                <Button label="Cancelar" icon="pi-md-close" onClick={this.cerrarModalDos} className="p-button-danger" />
            </div>
        );

        const pieDialogEliminarDos = (
            <div>
                <Button icon="pi-md-check" onClick={this.eliminarSubsidio} label="Si estoy seguro" />
                <Button icon="pi-md-close" onClick={this.cerrarModalEliminarDos} label="No estoy seguro" className="p-button-danger flat-btn" />
            </div>
        );

        return (
            <div className="p-grid">
                <Growl ref={(el) => this.growl = el} />
                <div className="card card-w-title">
                    <div className="p-fluid p-grid">
                        <div className="p-col-12 p-md-12">
                            <h1>ISR MENSUAL</h1>
                        </div>

                        <div className="card card-w-title">
                            <div className="p-grid">

                                <div className="p-col-12 p-md-6">
                                    <DataTable value={paginacion.datos} header="IMPUESTO SOBRE LA RENTA" responsive={true} paginator={true} rows={5}>
                                        <Column header="LIMITÉ INFERIOR" field="limiteInferior" autolayout={true} style={{ width: '110px' }} />
                                        <Column header="CUOTA FIJA" field="cuotaFija" autolayout={true} style={{ width: '90px' }} />
                                        <Column header="PORCENTAJE" body={this.columnaPorcentaje} autolayout={true} style={{ width: '90px' }} />
                                        {desarrollador === true ?
                                            <Column header="OPCIONES" body={this.plantillaOpciones} autolayout={true} style={{ width: '60px' }} />
                                            : null}
                                    </DataTable>
                                </div>

                                <div className="p-col-12 p-md-1">
                                    <label></label>
                                </div>

                                <div className="p-col-12 p-md-5">
                                    <DataTable value={paginacionS.datos} header="SUBSIDIO AL EMPLEO MENSUAL" responsive={true} paginator={true} rows={5}>
                                        <Column header="LIMITÉ INFERIOR" field="limiteInferior" autolayout={true} style={{ width: '110px' }} />
                                        <Column header="SUBSIDIO" field="subsidio" autolayout={true} style={{ width: '90px' }} />
                                        {desarrollador === true ?
                                            <Column header="EDITAR" body={this.plantillaOpcionesDos} autolayout={true} style={{ width: '60px' }} />
                                            : null}
                                    </DataTable>
                                </div>
                                <Dialog style={{ width: '50%', hidth: '40%' }} appent={document.body} header="Editar registro - ISR Mensual" visible={mostrarDialog}
                                    modal={true} onHide={this.cerrarModal} footer={pieDialogEditar}>
                                    <div className="p-grid">
                                        <div className="p-col-12 p-md-3">
                                            <label style={{ width: "30%" }}><strong>*Limité Inferior:</strong></label>
                                        </div>
                                        <div className="p-col-12 p-md-3">
                                            <InputText id="isr.limiteInferior" name="isr.limiteInferior" value={isr.limiteInferior || ""} className={errores.limiteInferior ? "p-error" : ""}
                                                placeholder="Limité" onChange={(e) => this.asignarValor(e, true)} maxLength="10" keyfilter="num" style={{ width: "100%" }} />
                                            {errores.limiteInferior ? <Message severity="error" text={errores.limiteInferior} /> : null}
                                        </div>

                                        <div className="p-col-12 p-md-3">
                                            <label style={{ width: "30%" }}><strong>*Cuota Fija:</strong></label>
                                        </div>
                                        <div className="p-col-12 p-md-3">
                                            <InputText id="isr.cuotaFija" name="isr.cuotaFija" value={isr.cuotaFija || ""} className={errores.cuotaFija ? "p-error" : ""}
                                                placeholder="Cuota" onChange={(e) => this.asignarValor(e, true)} maxLength="10" keyfilter="num" style={{ width: "100%" }} />
                                            {errores.cuotaFija ? <Message severity="error" text={errores.cuotaFija} /> : null}
                                        </div>

                                        <div className="p-col-12 p-md-3">
                                            <label style={{ width: "30%" }}><strong>*Porcentaje:</strong></label>
                                        </div>
                                        <div className="p-col-12 p-md-3">
                                            <InputText id="isr.porcentaje" name="isr.porcentaje" value={isr.porcentaje || ""} className={errores.porcentaje ? "p-error" : ""}
                                                placeholder="%" onChange={(e) => this.asignarValor(e, true)} maxLength="10" keyfilter="num" style={{ width: "100%" }} />
                                            {errores.porcentaje ? <Message severity="error" text={errores.porcentaje} /> : null}
                                        </div>
                                    </div>
                                </Dialog>
                                <Dialog style={{ width: '50%', hidth: '40%' }} appent={document.body} header="Editar registro - Subsidio al Empleo Mensual" visible={mostrarDialogDos}
                                    modal={true} onHide={this.cerrarModalDos} footer={pieDialogEditarDos}>
                                    <div className="p-grid">
                                        <div className="p-col-12 p-md-3">
                                            <label style={{ width: "30%" }}><strong>*Limité Inferior:</strong></label>
                                        </div>
                                        <div className="p-col-12 p-md-3">
                                            <InputText id="isr.limiteInferior" name="isr.limiteInferior" value={isr.limiteInferior || ""} className={errores.limiteInferior ? "p-error" : ""}
                                                placeholder="Limité" onChange={(e) => this.asignarValor(e, true)} maxLength="10" keyfilter="num" style={{ width: "100%" }} />
                                            {errores.limiteInferior ? <Message severity="error" text={errores.limiteInferior} /> : null}
                                        </div>

                                        <div className="p-col-12 p-md-3">
                                            <label style={{ width: "30%" }}><strong>*Subsidio:</strong></label>
                                        </div>
                                        <div className="p-col-12 p-md-3">
                                            <InputText id="isr.subsidio" name="isr.subsidio" value={isr.subsidio || ""} className={errores.subsidio ? "p-error" : ""}
                                                placeholder="Subsidio" onChange={(e) => this.asignarValor(e, true)} maxLength="10" keyfilter="num" style={{ width: "100%" }} />
                                            {errores.subsidio ? <Message severity="error" text={errores.subsidio} /> : null}
                                        </div>
                                    </div>
                                </Dialog>
                            </div>
                            <div className="p-grid">

                                <Dialog style={{ width: '50%', height: '30%' }} header="Eliminar registro - ISR" visible={mostrarModalEliminar} modal={true}
                                    footer={pieDialogEliminar} onHide={this.cerrarModalEliminar}>
                                    <div className="p-grid">
                                        <div className="p-col-12 p-md-12">
                                            <center><h2><strong>¿Estás seguro de eliminar este registro?</strong></h2></center>
                                        </div>
                                    </div>
                                </Dialog>

                                <Dialog style={{ width: '50%', height: '30%' }} header="Eliminar registro - Subsidio al Empleo Mensual" visible={mostrarModalEliminarDos} modal={true}
                                    footer={pieDialogEliminarDos} onHide={this.cerrarModalEliminarDos}>
                                    <div className="p-grid">
                                        <div className="p-col-12 p-md-12">
                                            <center><h2><strong>¿Estás seguro de eliminar este registro?</strong></h2></center>
                                        </div>
                                    </div>
                                </Dialog>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        );
    }
}